export default function ContactSupport() {

  return (
      <p>تماس با پشتیبانی</p>
  );
};